var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 306.204,
    height: 135.835,
    viewBox: "0 0 306.204 135.835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        stroke: #221f1f;\n        stroke-miterlimit: 10;\n        stroke-width: 0.25px;\n      }\n\n      .cls-3 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-4 {\n        fill: #1954f4;\n      }\n\n      .cls-5 {\n        fill: #6de9ab;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    className: "cls-1",
    d: "M5257.015,213.89l-137.92,135.835H5227.36Z",
    transform: "translate(-5119.095 -213.89)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(-5074.115 -213.89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(5074.24 247.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    className: "cls-2",
    d: "M5154.6,234.936v79.029h-18.232V301.809c-3.71,5.191-13.795,14.383-30.25,14.383-20.61,0-31.876-11.716-31.876-30.1V234.936h18.234v45.669c0,13.345,7.269,20.756,21.651,20.756s22.24-8.3,22.24-20.756V234.936Z",
    transform: "translate(-5074.24 -232.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    className: "cls-2",
    d: "M5218.014,281.219h-71.166c2.073,13.491,11.714,22.392,28.316,22.392,15.425,0,21.942-7.415,24.617-13.049h16.013c-4.007,16.159-19.427,26.54-40.63,26.54-22.533,0-44.772-12.9-44.772-41.667,0-28.317,21.792-41.808,44.48-41.808C5199.927,233.627,5220.093,248.453,5218.014,281.219Zm-16.3-13.345c-2.377-12.455-10.975-20.756-26.837-20.756-14.68,0-24.762,8.3-27.583,20.756Z",
    transform: "translate(-5035.173 -233.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    className: "cls-2",
    d: "M5275.268,313.965h-22.393l-23.72-28.612-23.575,28.612h-22.539l34.253-40.029-31.88-39h22.392l21.35,27.583,21.5-27.583h22.386l-31.876,39Z",
    transform: "translate(-4998.543 -232.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    className: "cls-2",
    d: "M5263,280.958a10.157,10.157,0,1,1-10.082-10.083A10.089,10.089,0,0,1,5263,280.958Z",
    transform: "translate(-4957.046 -207.712)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(5150.303 213.89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(-76.055 33.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    className: "cls-4",
    d: "M5154.6,234.939V313.97h-18.232V301.812c-3.71,5.191-13.794,14.383-30.25,14.383-20.61,0-31.876-11.714-31.876-30.1V234.939h18.234v45.67c0,13.345,7.271,20.756,21.651,20.756s22.241-8.3,22.241-20.756v-45.67Z",
    transform: "translate(-5074.245 -232.719)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    className: "cls-4",
    d: "M5218.02,281.222h-71.166c2.074,13.491,11.714,22.392,28.316,22.392,15.424,0,21.944-7.415,24.617-13.049H5215.8c-4.006,16.159-19.425,26.54-40.629,26.54-22.532,0-44.774-12.9-44.774-41.667,0-28.317,21.794-41.808,44.482-41.808C5199.933,233.63,5220.1,248.456,5218.02,281.222Zm-16.3-13.345c-2.378-12.453-10.976-20.756-26.838-20.756-14.679,0-24.763,8.3-27.582,20.756Z",
    transform: "translate(-5035.179 -233.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    className: "cls-4",
    d: "M5275.271,313.97H5252.88l-23.721-28.614-23.575,28.614h-22.537l34.252-40.031-31.882-39h22.393l21.35,27.583,21.5-27.583h22.386l-31.875,39Z",
    transform: "translate(-4998.549 -232.719)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    className: "cls-5",
    d: "M5263,280.962a10.157,10.157,0,1,1-10.082-10.085A10.089,10.089,0,0,1,5263,280.962Z",
    transform: "translate(-4957.051 -207.715)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.4347d89d8642b2763a1b1298b68df0ba.svg";
export { ForwardRef as ReactComponent };